document.querySelectorAll("[data-form]").forEach((form) => {
  const status = form.querySelector("[data-form-status]");

  form.addEventListener("submit", (event) => {
    event.preventDefault();

    if (!form.checkValidity()) {
      form.reportValidity();
      return;
    }

    if (status) {
      status.textContent = "Thank you. Your submission has been captured for the Brighten Group team.";
    }

    form.reset();
  });
});
